import AttentionModal from './attention';

export default AttentionModal;
